<template>
  <div>
    <keep-alive :include="cacheViews" :max="10">
      <router-view :key="routeCacheKey" />
    </keep-alive>
  </div>
</template>
<script setup>
import { useBaseLayout } from './hooks'

// keep-alive 的 :include 已按组件 name 精确控制缓存：
// 命中 cacheViews 的页面（如 Home）被缓存，未命中的页面（如 My）正常挂载/卸载。
// 因此无需再用 v-if 切换双 router-view —— 双 router-view 会在切换时
// 让被缓存组件被额外实例化一次，导致其 created 重新触发、重复请求接口。
const { cacheViews, routeCacheKey } = useBaseLayout()
</script>
